import { useConfig } from 'context/useConfig';
import { Baskervville } from 'next/font/google';
import { useEffect, useState } from 'react';

const baskervville = Baskervville({
  subsets: ['latin'],
  weight: ['400'],
  display: 'swap',
});

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

export const GreetingHeader = () => {
  const { user } = useConfig();
  const firstName = user?.name?.split(' ')[0] ?? '';

  // Render client-only to avoid SSR hydration mismatch on time-of-day
  const [greeting, setGreeting] = useState('');
  useEffect(() => {
    setGreeting(getGreeting());
  }, []);

  if (!greeting) return null;

  return (
    <div className="flex flex-col gap-xs">
      <h1
        className={`text-3xl leading-8 font-medium text-text-primary ${baskervville.className}`}
      >
        {firstName ? `${greeting}, ${firstName}` : greeting}
      </h1>
      <p
        className={`text-xl leading-[26px] text-text-secondary ${baskervville.className}`}
      >
        Here&apos;s what needs your attention today
      </p>
    </div>
  );
};
